import { createSchema, ZodOutputFor } from "@opstel/query/zod-utils";
import { PlainMessage } from "@bufbuild/protobuf";
import { Location_Crossing } from "@opstel/gen/knop/ui/v1/model/location_pb";
import { pointSchema } from "@opstel/query/models/point";
import { z } from "zod/v3";
import { Point } from "@opstel/geo/Point";

export interface Crossing {
  code: string;
  coordinate: Point;
  connectionLeftA: string;
  connectionLeftB: string;
  connectionRightA: string;
  connectionRightB: string;
}

export const crossingSchema = createSchema<Crossing, PlainMessage<Location_Crossing>>({
  code: z.string().min(1, "Crossing code should not be empty"),
  coordinate: pointSchema,
  connectionLeftA: z.string().min(1, "Crossing connectionLeftA should not be empty"),
  connectionLeftB: z.string().min(1, "Crossing connectionLeftB should not be empty"),
  connectionRightA: z.string().min(1, "Crossing connectionRightA should not be empty"),
  connectionRightB: z.string().min(1, "Crossing connectionRightB should not be empty"),
}) satisfies ZodOutputFor<Crossing>;
